import { SyncAction } from '@shared/models/sync/sync-action';
import { SyncActionDisplay } from '@modules/shared/sync-center/models/sync-action-display';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { groupSyncActionsByParent } from './utils/group-sync-actions-by-parent';
import { selectSyncDisplaySlices, syncDisplayResolvers } from './producers/sync-producers';
import { SyncState } from './sync.state';

export const SYNC_FEATURE_KEY = 'Sync';

export const selectSyncState = createFeatureSelector<SyncState>(SYNC_FEATURE_KEY);

export const selectAllSyncActions = createSelector(selectSyncState, (state): SyncAction[] => Object.values(state));

// Feeds the sync-center generically: groups every synced child by parent, delegates each group to
// its parent-type resolver, then orders the result most recent first (an item whose creation date
// isn't known yet goes last) so the list doesn't depend on which client's sessions came back first.
// Resolvers read their business detail from the producer slices composed in selectSyncDisplaySlices;
// groups whose parent type has no resolver are skipped.
export const selectSyncActionDisplays = createSelector(
  selectAllSyncActions,
  selectSyncDisplaySlices,
  (actions, slices): SyncActionDisplay[] =>
    groupSyncActionsByParent(actions)
      .map(({ parent, children }) => syncDisplayResolvers[parent.type]?.(parent, children, slices))
      .filter((display): display is SyncActionDisplay => !!display)
      .sort((first, second) => (second.date?.getTime() ?? 0) - (first.date?.getTime() ?? 0)),
);
